import jwtDecode from 'jwt-decode';
import { STORAGE } from '../constants';
import { GlobalWorkerOptions } from 'pdfjs-dist/build/pdf';
export function setPdfWorker(workerSrcOrClass) {
  if (typeof window !== 'undefined') delete window.pdfjsWorker;
  delete GlobalWorkerOptions.workerSrc;
  delete GlobalWorkerOptions.workerPort;

  if (typeof workerSrcOrClass === 'string') {
    GlobalWorkerOptions.workerSrc = workerSrcOrClass;
  } else if (typeof workerSrcOrClass === 'function') {
    GlobalWorkerOptions.workerPort = workerSrcOrClass();
  } else if (workerSrcOrClass instanceof Worker) {
    GlobalWorkerOptions.workerPort = workerSrcOrClass;
  } else if (typeof window !== 'undefined' && workerSrcOrClass) {
    window.pdfjsWorker = workerSrcOrClass;
  }
}
export var millisToMinutesAndSeconds = function millisToMinutesAndSeconds(millis) {
  var minutes = Math.floor(millis / 60000);
  var seconds = (millis % 60000 / 1000).toFixed(0);
  return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
};
export var clearSelection = function clearSelection() {
  if (window.getSelection) {
    window.getSelection().removeAllRanges();
  } else if (document.selection) {
    document.selection.empty();
  }
};
export var fileToBase64 = function fileToBase64(file) {
  var reader = new FileReader();
  return new Promise(function (resolve, reject) {
    reader.onload = function (event) {
      resolve(event.target.result);
    };

    reader.onerror = function (error) {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
};
export var hasValidToken = function hasValidToken() {
  var token = localStorage.getItem(STORAGE.authToken);
  if (!token) return false;

  var _jwtDecode = jwtDecode(token),
      exp = _jwtDecode.exp;

  return exp >= Date.now() / 1000;
};
export var makeThumb = function makeThumb(page, handleClick) {
  var vp = page.getViewport({
    scale: 1
  });
  var canvas = document.createElement('canvas');
  var currentPageNum = page.pageNumber - 1;
  canvas.width = 100;
  canvas.height = 148;
  canvas.style.position = 'relative';
  canvas.id = currentPageNum;
  canvas.className = 'border-2 mx-auto my-2 cursor-pointer hover:shadow-outline';
  canvas.onclick = handleClick;

  if (!currentPageNum) {
    canvas.classList.add('border-positive');
  }

  var scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);
  return page.render({
    canvasContext: canvas.getContext('2d'),
    viewport: page.getViewport({
      scale: scale
    })
  }).promise.then(function () {
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = 'r#3a8a9e';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = '30px Verdana';
    return canvas;
  });
};
export var handleError = function handleError(error) {
  var _error$data;

  return (error === null || error === void 0 ? void 0 : (_error$data = error.data) === null || _error$data === void 0 ? void 0 : _error$data.Error) || (error === null || error === void 0 ? void 0 : error.message) || typeof error === 'string' && error || 'Something went wrong';
};
export var bytesToSize = function bytesToSize(bytes) {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return 'n/a';
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) return bytes + " " + sizes[i] + ")";
  return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
};